import { Pipe, PipeTransform } from '@angular/core';

import { DossierUtils } from '../../core';

@Pipe({
  name: 'dossierStateTranslationKey'
})
export class DossierStateTranslationKeyPipe implements PipeTransform {
  transform(state: string, isTooltip?: boolean): string {
    // We totally reworked the handling of the status/type/...
    // So high likely we missed some cases, therefore check if the state
    // is undefined and dont show a translation-key with undefined, but show
    // just an empty string as a placeholder.
    if (!state || !state.length) {
      return '';
    }

    if (isTooltip) {
      return DossierUtils.getTooltipTranslationKey(state);
    } else {
      return DossierUtils.getTranslationKey(state);
    }
  }
}
